import React from "react"
//import PersonalAccidentImg from "../content/img/PersonalAccident.png"
import * as Constants from "../../../common/constants"
import PassedAwayImg from "../../../content/img/PA/PassedAway.png"
import InsuredDisabledImg from "../../../content/img/PA/PermanentlyDisabled.png"
import RequiredMedicalAttentionImg from "../../../content/img/PA/OutPatientMedical.png"
import ChildImg from "../../../content/img/PA/Child.svg"
import LossAndDamageOfBicycleImg from "../../../content/img/PA/DamageLoss.png"
import OptionalImg from "../../../content/img/PA/Optional.svg"
import OtherImg from "../../../content/img/PA/Others.png"

const BenefitFormHeader = ({
  chosenedBenefits,
  pageNumber,
  coverageHeaderId,
  coverageHeaderName,
  children,
}) => {
  function isChosen(type, Id) {
    const result = chosenedBenefits.find(
      e => e["Coverage" + type + "Id"] === Id
    )
    return typeof result != "undefined" ? true : false
  }

  const iconImgName = Id => {
    switch (Id) {
      case Constants.passedAwayCoverageHeaderId:
        return PassedAwayImg
      case Constants.insuredDisabledCoverageHeaderId:
        return InsuredDisabledImg
      case Constants.requiredMedicalAttentionCoverageHeaderId:
        return RequiredMedicalAttentionImg
      case Constants.childCoverageHeaderId:
        return ChildImg
      case Constants.lossAndDamageOfBicycleCoverageHeaderId:
        return LossAndDamageOfBicycleImg
      case Constants.optionalCoverageHeaderId:
        return OptionalImg
      case Constants.otherCoverageHeaderId:
        return OtherImg
      default:
        break
    }
  }

  return (
    <>
      <div>
        {coverageHeaderName !== Constants.basicCoverageDetailName && (
          <>
            <div
              className={
                "borderBottomDottedGrey noPaddingLeftRightSmallScreen mb-4 bigScreenNarrowing " +
                (pageNumber === Constants.reviewPageNumber &&
                isChosen("Header", coverageHeaderId)
                  ? ""
                  : "hide")
              }
            >
              <div className={"col-12 benefitsHeaderSummaryDiv "}>
                <img
                  className="benefitHeaderIcon"
                  src={iconImgName(coverageHeaderId)}
                  alt=""
                ></img>
                {coverageHeaderName}
              </div>
            </div>
            <div>{children}</div>
          </>
        )}
      </div>
    </>
  )
}

export default BenefitFormHeader
